export enum UserPaymentDetailsQueryKeys {
  MeDefault = '/user-payment-details/me',
  MeInfinity = '/user-payment-details/me-infinity',
  ById = '/user-payment-details/:id',
}
